import { formatDate as formatDateFNS } from 'date-fns';

const formatDate = (date: Date | string | null, format?: string): string =>
{
	let dateObj: Date;
	if (typeof date === 'string')
	{
		if (date === 'Unknown')
		{
			return 'Unknown';
		}

		dateObj = new Date(date);
	}
	else if (date === null)
	{
		dateObj = new Date();
	}
	else
	{
		dateObj = date;
	}

	try
	{
		if (format)
		{
			return formatDateFNS(dateObj, format);
		}
		return formatDateFNS(dateObj, 'MMM d, yyyy');
	}
	catch (e)
	{
		return dateObj.toLocaleString();
	}
};

export default formatDate;
